import DateFnsUtils from '@date-io/date-fns'
import { StandardTextFieldProps, TextField, TextFieldProps, makeStyles } from '@material-ui/core'
import { KeyboardDatePicker, KeyboardDatePickerProps, MuiPickersUtilsProvider } from '@material-ui/pickers'

// A date value is "credible" when it isn't an empty/zero-date sentinel (was @scoir/date's isCredibleDate).
const EMPTY_DATE_VALUES: ReadonlyArray<unknown> = [undefined, null, '', '0001-01-01', '0001-01-01T00:00:00Z']
const isCredibleDate = (date: Date | string) => !EMPTY_DATE_VALUES.includes(date)

const invalidErrorTextId = `date-invalid-error-id-${Math.random().toString(36).substr(2, 9)}`
const minErrorTextId = `date-min-error-id-${Math.random().toString(36).substr(2, 9)}`
const maxErrorTextId = `date-max-error-id-${Math.random().toString(36).substr(2, 9)}`

const CustomTextField = (textFieldProps: TextFieldProps) => {
  const inputProps = {
    'aria-describedby': `${invalidErrorTextId} ${minErrorTextId} ${maxErrorTextId}`,
  }
  return (
    <TextField
      {...textFieldProps}
      inputProps={{
        ...inputProps,
        form: { autoComplete: 'off' },
      }}
      margin="none"
      fullWidth
    />
  )
}

const useStyles = makeStyles(() => ({
  picker: {
    minWidth: '215px',
  },
}))

interface DatePickerProps
  extends Omit<KeyboardDatePickerProps, 'value' | 'InputProps'>,
    Omit<StandardTextFieldProps, 'onChange' | 'onError' | 'variant'> {
  date: Date | string
  onChange: (date: Date | null) => void
  pickerIdSuffix: string
}

const DatePicker = ({ date, onChange, pickerIdSuffix, ...datePickerProps }: DatePickerProps) => {
  const value = isCredibleDate(date) ? date : null
  const classes = useStyles()
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        {...datePickerProps}
        className={classes.picker}
        value={value}
        autoOk
        margin="normal"
        variant="inline"
        inputVariant="outlined"
        KeyboardButtonProps={{ 'aria-label': 'change date' }}
        id={`${pickerIdSuffix}-date-picker`}
        onChange={onChange as any}
        error={Boolean(datePickerProps.error)}
        TextFieldComponent={CustomTextField}
      />
    </MuiPickersUtilsProvider>
  )
}

export default DatePicker
